import { JsonObject, JsonProperty } from 'json2typescript';

import { Concept } from './concept';
import { DictionaryInterface } from '../../../core';
import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';

@JsonObject('Dictionary')
export class Dictionary implements DictionaryInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('Name', String, true)
    private _name: string = undefined;

    @JsonProperty('Concepts', [Concept], true)
    private _concepts: Concept[] = undefined;

    get id(): Id {
        return this._id;
    }

    get name(): string {
        return this._name;
    }

    get concepts(): Concept[] {
        return this._concepts;
    }
}
